import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Settings } from 'src/app/app.settings.model';
import { FindTimeResultItem } from 'src/app/core/models/find-time-result-item-model';
import { AppSettings } from 'src/app/app.settings';
import { Router } from '@angular/router';
import { StandbyService } from '../standby/standby.service';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { ApiResponseCode, SchedulerEventType } from 'src/app/core/enums';
import { TranslateService } from '@ngx-translate/core';
import { find } from 'rxjs/operators';
import moment from 'moment';
import { SchedulerService } from '../scheduler/scheduler.service';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { VisitItem } from 'src/app/core/models/visit-item';
import { AppData } from 'src/app/app.data';



@Component({
  selector: 'app-find-time-result',
  templateUrl: './find-time-result.component.html',
  styleUrls: ['./find-time-result.component.scss']
})
export class FindTimeResultComponent implements OnInit {

  error: string;
  settings: Settings;
  selectedFindTimeGroupItem: FindTimeResultItem;
  findTimeList: FindTimeResultItem[] = [];
  // visitItem: VisitItem;


  startTime: string;
  endTime: string;
  customerID: number;
  schedulerName: string;
  showNoItemsFoundMessage: boolean = false;

  constructor(private appSettings: AppSettings,
    private location: Location,
    private router: Router,
    private findtimeService: FindTimeService,
    private schedulerService: SchedulerService,
    private translate: TranslateService,
    private appData: AppData) {

    this.settings = appSettings.settings;
    this.selectedFindTimeGroupItem = appData.selectedFindTimeResultItemGroup;
    this.schedulerName = this.selectedFindTimeGroupItem && this.selectedFindTimeGroupItem.SchedulerName || null;
    // this.visitItem = this.findtimeService.visitItem;


  }

  ngOnInit() {
    // get startTime and and time
    const findTimeForm = this.appData.formStateFindTime;
    const waitlistItem = this.appData.waitlistItem;

    if (findTimeForm) {
      this.startTime = findTimeForm.startTime || '';
      this.endTime = findTimeForm.endTime || '';
      this.customerID = findTimeForm.patient.EntityID || 0;
    }
    if (waitlistItem) {
      this.startTime = waitlistItem.FromTime || '08:00';
      this.endTime = waitlistItem.ToTime || '18:00';
      this.customerID = waitlistItem.CustomerID || 0;
    }
    // else if (this.visitItem) {
    //   const startAt = moment(this.visitItem.StartAt);
    //   const duration = this.visitItem.Duration;
    //   this.startTime =  startAt.format('LT') || ''; // HH:mm
    //   this.endTime = startAt.add(duration, 'minutes').format('LT') || '';
    //   this.customerID = this.visitItem.CustomerID;
    // }

    this.loadFindTimeItems();

  }

  loadFindTimeItems() {
    const dataToSend = this.buildDataToSend();
    this.showNoItemsFoundMessage = false;
    if (dataToSend) {
      this.findtimeService.findTime(dataToSend).subscribe(
        res => {
          if (res.Code === ApiResponseCode.Success) {            
            this.findTimeList = res.Data.map(item => new FindTimeResultItem(item));
            this.showNoItemsFoundMessage = this.findTimeList.length === 0;
          } else {
            this.error = this.translate.instant(`ERROR.CODE.${res.Code}`);
          }
        },
        err => {
          this.error = err;
        }
      );
    }
  }

  buildDataToSend(): FindTimeResultItem {
    if (this.selectedFindTimeGroupItem) {
      const obj = new FindTimeResultItem(this.selectedFindTimeGroupItem);
      obj.StartTime = this.startTime;
      obj.EndTime = this.endTime;
      return obj;
    }

    // if (this.visitItem) {
    //   const obj = new FindTimeResultItem(this.visitItem);
    //   const tmp = this.visitItem;
    //   obj.StartTime = '00:00';//tmp.StartAt.format('LT');
    //   obj.EndTime = '00:00'; //tmp.StartAt.add(tmp.Duration, 'minutes').format('LT');      
    //   return obj;
    // }
    return null;
  }

  back() {
    this.location.back();
  }

  onSelect(item: FindTimeResultItem) {
    this.appData.selectedFindTimeResultItem = item;
    this.router.navigate(['/create-appointment']);
  }

}
